export default __webpack_public_path__ + "static/media/thumbnail.841d11d8.png";